export default __webpack_public_path__ + "static/media/inside-the-pod.01f2a167.gif";